import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const HeadingBlock = styled(Block)`
  ${paddingBuilder.all(0, 1)}
  margin-bottom: ${themeSpace(3)};
  text-align: center;

  ${tablet768`
    width: 100%;
  `}

  ${desktop1024`
    ${paddingBuilder.all(0)}
    width: 50%;
    margin-bottom: 0px;
    text-align: left;
  `}
`;

HeadingBlock.displayName = 'HeadingBlock';

export default HeadingBlock;
